/* eslint-disable i18next/no-literal-string */
import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void) {
  window.addEventListener("resize", onChange);
  return () => window.removeEventListener("resize", onChange);
}

export function BreakpointIndicator() {
  // Hydrates with the server's 0, then shows the real width, so the markup matches.
  const width = useSyncExternalStore(
    subscribe,
    () => window.innerWidth,
    () => 0,
  );

  // Shown on dev, staging and preview builds; hidden on production.
  if (import.meta.env.MODE === "production") {return null;}

  // Visual-only dev aid; hidden from assistive tech so it doesn't count as unlandmarked content.
  return (
    <div aria-hidden="true" className="fixed top-0 left-0 z-999999 rounded-br border-r border-b border-gray-300 bg-white px-1.5 py-1 text-xs text-black opacity-75">
      <span className="sm:hidden">default</span>
      <span className="hidden sm:inline md:hidden">sm</span>
      <span className="hidden md:inline lg:hidden">md</span>
      <span className="hidden lg:inline xl:hidden">lg</span>
      <span className="hidden xl:inline 2xl:hidden">xl</span>
      <span className="hidden 2xl:inline">2xl</span>
      <span> — {width}px</span>
    </div>
  );
}
